import {VNode} from '../vm/vnode';
const e = VNode.create;
export function a(args, ...children) {return e('a', args, ...children)}
export function abbr(args, ...children) {return e('abbr', args, ...children)}
export function acronym(args, ...children) {return e('acronym', args, ...children)}
export function address(args, ...children) {return e('address', args, ...children)}
export function applet(args, ...children) {return e('applet', args, ...children)}
export function area(args, ...children) {return e('area', args, ...children)}
export function article(args, ...children) {return e('article', args, ...children)}
export function aside(args, ...children) {return e('aside', args, ...children)}
export function audio(args, ...children) {return e('audio', args, ...children)}
export function b(args, ...children) {return e('b', args, ...children)}
export function base(args, ...children) {return e('base', args, ...children)}
export function basefont(args, ...children) {return e('basefont', args, ...children)}
export function bdi(args, ...children) {return e('bdi', args, ...children)}
export function bdo(args, ...children) {return e('bdo', args, ...children)}
export function bgsound(args, ...children) {return e('bgsound', args, ...children)}
export function big(args, ...children) {return e('big', args, ...children)}
export function blink(args, ...children) {return e('blink', args, ...children)}
export function blockquote(args, ...children) {return e('blockquote', args, ...children)}
export function body(args, ...children) {return e('body', args, ...children)}
export function br(args, ...children) {return e('br', args, ...children)}
export function button(args, ...children) {return e('button', args, ...children)}
export function canvas(args, ...children) {return e('canvas', args, ...children)}
export function caption(args, ...children) {return e('caption', args, ...children)}
export function center(args, ...children) {return e('center', args, ...children)}
export function cite(args, ...children) {return e('cite', args, ...children)}
export function code(args, ...children) {return e('code', args, ...children)}
export function col(args, ...children) {return e('col', args, ...children)}
export function colgroup(args, ...children) {return e('colgroup', args, ...children)}
export function content(args, ...children) {return e('content', args, ...children)}
export function data(args, ...children) {return e('data', args, ...children)}
export function datalist(args, ...children) {return e('datalist', args, ...children)}
export function dd(args, ...children) {return e('dd', args, ...children)}
export function decorator(args, ...children) {return e('decorator', args, ...children)}
export function del(args, ...children) {return e('del', args, ...children)}
export function details(args, ...children) {return e('details', args, ...children)}
export function dfn(args, ...children) {return e('dfn', args, ...children)}
export function dir(args, ...children) {return e('dir', args, ...children)}
export function div(args, ...children) {return e('div', args, ...children)}
export function dl(args, ...children) {return e('dl', args, ...children)}
export function dt(args, ...children) {return e('dt', args, ...children)}
export function element(args, ...children) {return e('element', args, ...children)}
export function em(args, ...children) {return e('em', args, ...children)}
export function embed(args, ...children) {return e('embed', args, ...children)}
export function fieldset(args, ...children) {return e('fieldset', args, ...children)}
export function figcaption(args, ...children) {return e('figcaption', args, ...children)}
export function figure(args, ...children) {return e('figure', args, ...children)}
export function font(args, ...children) {return e('font', args, ...children)}
export function footer(args, ...children) {return e('footer', args, ...children)}
export function form(args, ...children) {return e('form', args, ...children)}
export function frame(args, ...children) {return e('frame', args, ...children)}
export function frameset(args, ...children) {return e('frameset', args, ...children)}
export function h1(args, ...children) {return e('h1', args, ...children)}
export function h2(args, ...children) {return e('h2', args, ...children)}
export function h3(args, ...children) {return e('h3', args, ...children)}
export function h4(args, ...children) {return e('h4', args, ...children)}
export function h5(args, ...children) {return e('h5', args, ...children)}
export function h6(args, ...children) {return e('h6', args, ...children)}
export function head(args, ...children) {return e('head', args, ...children)}
export function header(args, ...children) {return e('header', args, ...children)}
export function hgroup(args, ...children) {return e('hgroup', args, ...children)}
export function hr(args, ...children) {return e('hr', args, ...children)}
export function html(args, ...children) {return e('html', args, ...children)}
export function i(args, ...children) {return e('i', args, ...children)}
export function iframe(args, ...children) {return e('iframe', args, ...children)}
export function img(args, ...children) {return e('img', args, ...children)}
export function input(args, ...children) {return e('input', args, ...children)}
export function ins(args, ...children) {return e('ins', args, ...children)}
export function isindex(args, ...children) {return e('isindex', args, ...children)}
export function kbd(args, ...children) {return e('kbd', args, ...children)}
export function keygen(args, ...children) {return e('keygen', args, ...children)}
export function label(args, ...children) {return e('label', args, ...children)}
export function legend(args, ...children) {return e('legend', args, ...children)}
export function li(args, ...children) {return e('li', args, ...children)}
export function link(args, ...children) {return e('link', args, ...children)}
export function listing(args, ...children) {return e('listing', args, ...children)}
export function main(args, ...children) {return e('main', args, ...children)}
export function map(args, ...children) {return e('map', args, ...children)}
export function mark(args, ...children) {return e('mark', args, ...children)}
export function marquee(args, ...children) {return e('marquee', args, ...children)}
export function menu(args, ...children) {return e('menu', args, ...children)}
export function menuitem(args, ...children) {return e('menuitem', args, ...children)}
export function meta(args, ...children) {return e('meta', args, ...children)}
export function meter(args, ...children) {return e('meter', args, ...children)}
export function nav(args, ...children) {return e('nav', args, ...children)}
export function nobr(args, ...children) {return e('nobr', args, ...children)}
export function noframes(args, ...children) {return e('noframes', args, ...children)}
export function noscript(args, ...children) {return e('noscript', args, ...children)}
export function object(args, ...children) {return e('object', args, ...children)}
export function ol(args, ...children) {return e('ol', args, ...children)}
export function optgroup(args, ...children) {return e('optgroup', args, ...children)}
export function option(args, ...children) {return e('option', args, ...children)}
export function output(args, ...children) {return e('output', args, ...children)}
export function p(args, ...children) {return e('p', args, ...children)}
export function param(args, ...children) {return e('param', args, ...children)}
export function plaintext(args, ...children) {return e('plaintext', args, ...children)}
export function pre(args, ...children) {return e('pre', args, ...children)}
export function progress(args, ...children) {return e('progress', args, ...children)}
export function q(args, ...children) {return e('q', args, ...children)}
export function rp(args, ...children) {return e('rp', args, ...children)}
export function rt(args, ...children) {return e('rt', args, ...children)}
export function ruby(args, ...children) {return e('ruby', args, ...children)}
export function s(args, ...children) {return e('s', args, ...children)}
export function samp(args, ...children) {return e('samp', args, ...children)}
export function script(args, ...children) {return e('script', args, ...children)}
export function section(args, ...children) {return e('section', args, ...children)}
export function select(args, ...children) {return e('select', args, ...children)}
export function shadow(args, ...children) {return e('shadow', args, ...children)}
export function small(args, ...children) {return e('small', args, ...children)}
export function source(args, ...children) {return e('source', args, ...children)}
export function spacer(args, ...children) {return e('spacer', args, ...children)}
export function span(args, ...children) {return e('span', args, ...children)}
export function strike(args, ...children) {return e('strike', args, ...children)}
export function strong(args, ...children) {return e('strong', args, ...children)}
export function style(args, ...children) {return e('style', args, ...children)}
export function sub(args, ...children) {return e('sub', args, ...children)}
export function summary(args, ...children) {return e('summary', args, ...children)}
export function sup(args, ...children) {return e('sup', args, ...children)}
export function table(args, ...children) {return e('table', args, ...children)}
export function tbody(args, ...children) {return e('tbody', args, ...children)}
export function td(args, ...children) {return e('td', args, ...children)}
export function template(args, ...children) {return e('template', args, ...children)}
export function textarea(args, ...children) {return e('textarea', args, ...children)}
export function tfoot(args, ...children) {return e('tfoot', args, ...children)}
export function th(args, ...children) {return e('th', args, ...children)}
export function thead(args, ...children) {return e('thead', args, ...children)}
export function time(args, ...children) {return e('time', args, ...children)}
export function title(args, ...children) {return e('title', args, ...children)}
export function tr(args, ...children) {return e('tr', args, ...children)}
export function track(args, ...children) {return e('track', args, ...children)}
export function tt(args, ...children) {return e('tt', args, ...children)}
export function u(args, ...children) {return e('u', args, ...children)}
export function ul(args, ...children) {return e('ul', args, ...children)}
export function video(args, ...children) {return e('video', args, ...children)}
export function wbr(args, ...children) {return e('wbr', args, ...children)}
export function xmp(args, ...children) {return e('xmp', args, ...children)}

export default {
    a,
	abbr,
	acronym,
	address,
	applet,
	area,
	article,
	aside,
	audio,
	b,
	base,
	basefont,
	bdi,
	bdo,
	bgsound,
	big,
	blink,
	blockquote,
	body,
	br,
	button,
	canvas,
	caption,
	center,
	cite,
	code,
	col,
	colgroup,
	content,
	data,
	datalist,
	dd,
	decorator,
	del,
	details,
	dfn,
	dir,
	div,
	dl,
	dt,
	element,
	em,
	embed,
	fieldset,
	figcaption,
	figure,
	font,
	footer,
	form,
	frame,
	frameset,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	head,
	header,
	hgroup,
	hr,
	html,
	i,
	iframe,
	img,
	input,
	ins,
	isindex,
	kbd,
	keygen,
	label,
	legend,
	li,
	link,
	listing,
	main,
	map,
	mark,
	marquee,
	menu,
	menuitem,
	meta,
	meter,
	nav,
	nobr,
	noframes,
	noscript,
	object,
	ol,
	optgroup,
	option,
	output,
	p,
	param,
	plaintext,
	pre,
	progress,
	q,
	rp,
	rt,
	ruby,
	s,
	samp,
	script,
	section,
	select,
	shadow,
	small,
	source,
	spacer,
	span,
	strike,
	strong,
	style,
	sub,
	summary,
	sup,
	table,
	tbody,
	td,
	template,
	textarea,
	tfoot,
	th,
	thead,
	time,
	title,
	tr,
	track,
	tt,
	u,
	ul,
	// var_,
	video,
	wbr,
	xmp, e}
